import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check\"><path fill=\"#BAE860\" fill-rule=\"evenodd\" d=\"M12.04 0a12 12 0 1 1-.09 24 12 12 0 0 1 .09-24M6.97 11.91c-.85-.85-2.19.49-1.34 1.34 1.16 1.16 2.2 2.32 3.35 3.41.5.43.92.49 1.34 0l8.05-8.04c.85-.85-.43-2.2-1.34-1.34l-7.31 7.37z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol